import React, { Fragment } from 'react'
import { Button, Icon } from 'semantic-ui-react'

class GoogleWeatherBtn extends React.Component {
  constructor(props) {
    super (props)
  }

  getLink() {
    const { city } = this.props
    if(city) {
      return `https://www.google.com/search?query=weather+${city}`
    }
    return null
  }

  openLink = (link) => {
    window.open(link, '_blank')
  }

  render() {
    const link = this.getLink()
    return (
      <Fragment>
        { link &&
        <Button basic icon color='blue' onClick={this.openLink.bind(this, link)} style={{margin: '0', padding: '8px'}} title='Weather'>
          <Icon name='sun'/>
        </Button> }
      </Fragment>
    )
  }
}

export default GoogleWeatherBtn
